import { Component, Input, OnInit } from '@angular/core';

import {
  getProviderName,
  isPackage,
  ProductSelection
} from '@features/opportunities/models/product-selection/product-selection.model';
import { AdviserLabelCase } from '@shared/pipes/adviser-label.pipe';

@Component({
  selector: 'app-product-selection-display',
  templateUrl: './display.component.html',
  styleUrls: ['./display.component.scss']
})
export class ProductSelectionDisplayComponent implements OnInit {
  @Input()
  productSelection!: ProductSelection;
  adviserLabelCase = AdviserLabelCase;

  constructor() {}

  ngOnInit(): void {}



  public isPackage(details: ProductSelection): boolean {
    return isPackage(details);
  }

  getProviderName = getProviderName;
}
